// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"280": "829d1f00f467b1ae","397": "c42a63b5701261ac",}[chunkId] + ".css"
}